var React = require('react');

function ScrollTop (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"43.5","cy":"43.5","r":"43.5","fill":"#3B3221","key":0}),React.createElement("path",{"d":"M15.782 43.4011L43.8853 15.2979L71.7462 43.1588","stroke":"white","strokeWidth":"5","key":1}),React.createElement("path",{"d":"M43.6426 72.2301L43.6426 15.5391","stroke":"white","strokeWidth":"5","key":2})]);
}

ScrollTop.defaultProps = {"width":"87","height":"87","viewBox":"0 0 87 87","fill":"none"};

module.exports = ScrollTop;

ScrollTop.default = ScrollTop;
